import { useSyncExternalStore } from 'react'
import { vault } from './vault'

/** Re-renders when the vault locks / unlocks or an unlock prompt is requested. */
export function useVault() {
  return useSyncExternalStore(
    (cb) => vault.subscribe(cb),
    () => vaultSnapshot(),
  )
}

let last = ''
let cached = { unlocked: false, needsUnlock: false }
function vaultSnapshot() {
  const key = `${vault.unlocked}|${vault.needsUnlock}`
  if (key !== last) {
    last = key
    cached = { unlocked: vault.unlocked, needsUnlock: vault.needsUnlock }
  }
  return cached
}
